module.exports = __webpack_public_path__ + "static/img/u359.87bcb5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/task/u359.png
// module id = uHHy
// module chunks = 0